export const FILTERED_STUDENTS = 'FILTERED_STUDENTS';
export const ERROR_DETECTED = 'ERROR_DETECTED';

export const STUDENTS_ASSIGNMENTS_STATUSES_REQUEST = 'STUDENTS_ASSIGNMENTS_STATUSES_REQUEST';
export const STUDENTS_ASSIGNMENTS_STATUSES_SUCCESS = 'STUDENTS_ASSIGNMENTS_STATUSES_SUCCESS';

export const UPDATE_SORTED_STUDENTS_LIST = 'UPDATE_SORTED_STUDENTS_LIST';
export const PUBLICATIONS_ACQUIRED = 'PUBLICATIONS_ACQUIRED';

export const GENERIC_COURSES_REQUEST = 'GENERIC_COURSES_REQUEST';
export const GENERIC_COURSES_SUCCESS = 'GENERIC_COURSES_SUCCESS';

export const SHOW_TOAST = 'SHOW_TOAST';
export const CLASSROOMS_ACQUIRED = 'CLASSROOMS_ACQUIRED';
export const UPDATE_STRANDS = 'UPDATE_STRANDS';
export const UPDATE_SORT_PROPERTIES = 'UPDATE_SORT_PROPERTIES';
export const APPLY_FILTER = 'APPLY_FILTER';
export const UPDATE_SELECTED_COURSE = 'UPDATE_SELECTED_COURSE';
export const SHOW_HIDE_SEARCH_PANEL = 'SHOW_HIDE_SEARCH_PANEL';
export const DISPLAY_MODAL_INFORMATION = 'DISPLAY_MODAL_INFORMATION';
export const HIDE_STANDARD = 'HIDE_STANDARD';
export const UPDATE_STUDENT_ASSIGNMENT = 'UPDATE_STUDENT_ASSIGNMENT';
export const ASSIGN_REQUEST = 'ASSIGN_REQUEST';
export const ASSIGN_SUCCESS_REQUEST = 'ASSIGN_SUCCESS_REQUEST';
export const ASSIGN_FAILURE_REQUEST = 'ASSIGN_FAILURE_REQUEST';
export const GRID_CELL_SELECTION = 'GRID_CELL_SELECTION';
export const UNASSIGN_REQUEST = 'UNASSIGN_REQUEST';
export const UNASSIGN_SUCCESS_REQUEST = 'UNASSIGN_SUCCESS_REQUEST';
export const UNASSIGN_FAILURE_REQUEST = 'UNASSIGN_FAILURE_REQUEST';
export const EXPAND_COLLAPSE_REQUEST = 'EXPAND_COLLAPSE_REQUEST';
export const SET_SELECTED_CLASS = 'SET_SELECTED_CLASS';
export const SET_SELECTED_GROUP = 'SET_SELECTED_GROUP';
export const SET_SELECTED_PUBLICATION = 'SET_SELECTED_PUBLICATION';
export const SET_SELECTED_COURSE_OPTION = 'SET_SELECTED_COURSE_OPTION';
export const RESTRICT_ACCESS_REQUEST = 'RESTRICT_ACCESS_REQUEST';
export const RESTRICT_ACCESS_SUCCESS = 'RESTRICT_ACCESS_SUCCESS';
export const RESTRICT_ACCESS_FAILURE = 'RESTRICT_ACCESS_FAILURE';
export const SET_ASSIGNMENT_FILTER_TYPE = 'SET_ASSIGNMENT_FILTER_TYPE';
export const SELECT_ACCURACY_PROGRESS_TOGGLE = 'SELECT_ACCURACY_PROGRESS_TOGGLE';
export const SELECT_ACCURACY_SUB_FILTER = 'SELECT_ACCURACY_SUB_FILTER';
export const SELECT_PROGRESS_SUB_FILTER = 'SELECT_PROGRESS_SUB_FILTER';
export const QUICK_SELECTION = 'QUICK_SELECTION';

export const SELECT_ASSIGNMENT_HASH_KEY = 'SELECT_ASSIGNMENT_HASH_KEY';
export const SELECT_ASSIGNMENT_HASH_KEYS = 'SELECT_ASSIGNMENT_HASH_KEYS';
export const UNSELECT_ASSIGNMENT_HASH_KEYS = 'UNSELECT_ASSIGNMENT_HASH_KEYS';

export const RESET_SELECTED_ASSIGNMENT_HASH_KEYS = 'RESET_SELECTED_ASSIGNMENT_HASH_KEYS';

export const DISABLE_SHOW_GRID_LOADER = 'DISABLE_SHOW_GRID_LOADER';

export const UPDATE_SORTED_STUDENT_IDS = 'UPDATE_SORTED_STUDENT_IDS';

export const SET_DATE_CONFIGURATION = 'SET_DATE_CONFIGURATION';


// WEBPACK FOOTER //
// ./containers/upf-assign/upf-assign-action-types.js